import type { ReactNode } from 'react';
import { useSyncGate } from './SyncGateProvider';
import { InitialSyncScreen } from './InitialSyncScreen';

export function SyncGate({ children }: { children: ReactNode }) {
  const { phase } = useSyncGate();
  if (phase !== 'ready') return <InitialSyncScreen />;
  return <>{children}</>;
}
